import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Breadcrumbs,
  Typography,
  TextField,
  Container,
  Grid,
  Box,
  MenuItem,
  IconButton,
  Pagination,
  useMediaQuery,
} from "@mui/material";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import { getName } from "../Other/common";
import { toast } from "react-toastify";
import { useTheme } from "@emotion/react";
import { Select, FormControl, InputLabel } from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import { BASE_URL } from "../../urlConfig/Url";

const CategoryMaster = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [cid, setCID] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [plantCode, setPlantCode] = useState("");
  const [plantName, setPlantName] = useState("");
  const [plantAddress, setPlantAddress] = useState("");
  const [city, setCity] = useState("");

  const [description, setDescription] = useState("");
  const [deprec, setDeprec] = useState("");

  const [state, setState] = useState("");
  const [status, setStatus] = useState("");

  // error states
  const [plantAddressError, setPlantAddressError] = useState(false);
  const [descriptionError, setDescriptionError] = useState(false);
  const [deprecError, setDeprecError] = useState(false);
  const [stateError, setStateError] = useState(false);

  const [companies, setCompanies] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [cName, setCName] = useState([]);
  const [formMode, setFormMode] = useState("initial");

  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    fetchCompanies();
    //   fetchCompaniesName();
  }, []);

  const fetchCompanies = async () => {
    try {
      const response = await axios.post(
        BASE_URL + "/api/master/getAllCatogaryMaster"
      );
      if (response.data.success) {
        setCompanies(response.data.response);
      }
    } catch (error) {
      console.error("Error fetching company data:", error);
    }
  };

  // const fetchCompaniesName = async () => {
  //   try {
  //     const response = await axios.post(
  //        BASE_URL+"/api/master/getPlantCode"
  //     );
  //     if (response.data.success) {
  //       setCName(response.data.response);
  //     }
  //   } catch (error) {
  //     toast.error("Error fetching company data:", error);
  //   }
  // };


  const formvalidation = () => {
    let isValid = true;
    if (plantAddress.trim() === "") {
      setPlantAddressError(true);
      isValid = false;
    }else {
      setPlantAddressError(false);
    }
    if (description.trim() === "") {
      setDescriptionError(true);
      isValid = false;
    }else {
      setDescriptionError(false);
    }
    if (deprec.trim() === "") {
      setDeprecError(true);
      isValid = false;
    }else {
      setDeprecError(false);
    }
    if (state.trim() === "") {
      setStateError(true);
      isValid = false;
    }else {
      setStateError(false); 
    }

    return isValid;
  }

  const onSubmit = async () => {
    if (formvalidation()) {
      
    
    const data = {
      CategoryCode: plantAddress,
      Description: description,
      Depreciation: deprec,
      DepreciationYear: state,
      Createdby: getName().Name,
    };
    //   console.log(data);
    try {
      const response = await axios.post(
        BASE_URL + "/api/master/insertCategoryDetails",
        data
      );

      if (response.data.success) {
        toast.success(response.data.message);
        fetchCompanies();
        resetForm();
        setFormMode("initial");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error submitting company data:", error);
      toast.error("An error occurred while adding the company.");
    }
  }else {
    toast.error("Please fill all the fields");
  }
  };

  const onUpdate = async () => {
    const data = {
      CategoryCode: plantAddress,
      Description: description,
      Depreciation: deprec,
      DepreciationYear: state,
      ModifyBy: getName().Name,
    };
    // console.log(data)
    try {
      const response = await axios.post(
        BASE_URL + "/api/master/updateCategoryDetails",
        data
      );

      if (response.data.success) {
        toast.success(response.data.message);
        fetchCompanies();
        resetForm();
        setFormMode("initial");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error updating company data:", error);
      toast.error("An error occurred while updating the company.");
    }
  };

  const resetForm = () => {
    setCID("");
    setCompanyName("");
    setPlantCode("");
    setPlantName("");
    setPlantAddress("");
    setCity("");
    setState("");
    setStatus("");
    setDescription("");
    setDeprec("");
  };

  const handleAddNew = () => {
    setFormMode("add");
    resetForm();
  };

  const handleCancel = () => {
    resetForm();
    setFormMode("initial");
    stopErrorHelper();
  };

  useEffect(() => {
    const searchWords = searchTerm.toLowerCase().split(/\s+/).filter(Boolean);
    
    const result = companies.filter((company) =>
      searchWords.every((word) =>
        Object.entries(company).some(([key, value]) => {
          // Skip null or undefined values
          if (value == null) return false;
  
          // Convert to string and compare
          return value.toString().toLowerCase().includes(word);
        })
      )
    );
    setFilteredRows(result);
  }, [searchTerm, companies]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setPage(1);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const stopErrorHelper =()=>{
    setPlantAddressError(false);
    setDescriptionError(false);
    setDeprecError(false);
    setStateError(false);
  }

  const handleRowSelect = (company) => {
    setCID(company.Loc_Id);
    setPlantCode(company.PlantCode);
    setPlantName(company.PlantName);
    setPlantAddress(company.CategoryCode);
    setCity(company.City);
    setState(company.DepreciationYear);
    setDeprec(company.Depreciation);
    setStatus(company.Status);
    setDescription(company.Description);
    setCompanyName(company.CompanyName);
    setFormMode("edit");
    stopErrorHelper();
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const paginatedRows = filteredRows.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  return (
    <>
      <Container maxWidth="lg">
        <Box sx={{ mt: 1, mb: 2 }}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link
              to="/dashboard/dashbordhome"
              style={{
                textDecoration: "none",
                color: theme.palette.primary.main,
              }}
            >
              Home
            </Link>
            <Typography color="textPrimary">Asset Category Code</Typography>
          </Breadcrumbs>
        </Box>

        <Box sx={{ mt: 3, overflowX: "auto" }}>
          <Paper elevation={3} sx={{ padding: "2%" }}>
            <Typography variant="h6" mb={2} sx={{ textAlign: "left" }}>
              Asset Category Code (* Fields Are Mandatory)
            </Typography>

            <Grid container spacing={3}>
              {/* <Grid item xs={12} sm={3}>
              <TextField
                select
                label="Plant Code (*)"
                name="Plant Code"
                fullWidth
                size="small"
                value={plantCode}
                onChange={(e) => setPlantCode(e.target.value)}
                disabled={formMode === "view"}
              >
                {cName.map((company) => (
                  <MenuItem key={company.PlantCode} value={company.PlantCode}>
                    {company.PlantCode}
                  </MenuItem>
                ))}
              </TextField>
            </Grid> */}
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Category Code(*)"
                  name="Category"
                  fullWidth
                  size="small"
                  value={plantAddress}
                  error={plantAddressError}
                  helperText={plantAddressError? "Category Code is required" : ""}
                  onChange={(e) => setPlantAddress(e.target.value)}
                  disabled={formMode === "initial" || formMode === "edit"}
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  label="Category Description (*)"
                  name="Category Description"
                  fullWidth
                  size="small"
                  value={description}
                  error={descriptionError}
                  helperText={descriptionError? "Category Description is required" : ""}
                  onChange={(e) => setDescription(e.target.value)}
                  disabled={formMode === "initial"}
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  label="Depreciation (*)"
                  name="Depreciation"
                  fullWidth
                  size="small"
                  value={deprec}
                  error={deprecError}
                  helperText={deprecError? "Depreciation is required" : ""}
                  onChange={(e) => setDeprec(e.target.value)}
                  disabled={formMode === "initial"}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Depreciation Days (*)"
                  name="Depreciation Days"
                  fullWidth
                  size="small"
                  value={state}
                  error={stateError}
                  helperText={stateError? "Depreciation Days is required" : ""}
                  onChange={(e) => setState(e.target.value)}
                  disabled={formMode === "initial"}
                />
              </Grid>
              {/* <Grid item xs={12} sm={3}>
              <TextField
                select
                label="Status(*)"
                name="Status"
                fullWidth
                size="small"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Deactive">Deactive</MenuItem>
              </TextField>
            </Grid> */}
            </Grid>
            <Grid container justifyContent="flex-end" mt={5} spacing={1}>
              {formMode === "initial" && (
                <Grid item>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={handleAddNew}
                  >
                    <AddIcon />
                    Add New
                  </Button>
                </Grid>
              )}

              {formMode === "add" && (
                <>
                  <Grid item>
                    <Button variant="contained" size="small" onClick={onSubmit}>
                      <AddIcon />
                      Submit
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleCancel}
                    >
                      <CloseIcon />
                      Cancel
                    </Button>
                  </Grid>
                </>
              )}

              {formMode === "edit" && (
                <>
                  <Grid item>
                    <Button variant="contained" size="small" onClick={onUpdate}>
                      <ChangeCircleIcon />
                      Update
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleCancel}
                    >
                      <CloseIcon />
                      Cancel
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>
          </Paper>
        </Box>

        <Box sx={{ mt: 3, overflowX: "auto" }}>
          <Paper elevation={3} sx={{ padding: "2%" }}>
            <Box
              sx={{
                mb: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <FormControl
                variant="outlined"
                size="small"
                sx={{ minWidth: 100 }}
              >
                <InputLabel id="rows-per-page-label">Rows per page</InputLabel>
                <Select
                  labelId="rows-per-page-label"
                  value={rowsPerPage}
                  onChange={handleChangeRowsPerPage}
                  label="Rows per page"
                >
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </Select>
              </FormControl>
              <TextField
                label="Search"
                variant="outlined"
                size="small"
                value={searchTerm}
                onChange={handleSearchChange}
                sx={{ width: 250 }}
                InputProps={{
                  endAdornment: (
                    <IconButton>
                      <SearchIcon />
                    </IconButton>
                  ),
                }}
              />
            </Box>

            <div className="table-container">
              <table className="responsive-table">
                <thead>
                  <tr>
                    <th>Select</th>
                    <th>Category Code</th>
                    <th>Description</th>
                    <th>Depreciation</th>
                    <th>Depreciation Days</th>
                    <th>Created By</th>
                    <th>Created Date</th>
                    <th>Updated By</th>
                    <th>Updated Date</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedRows.map((company) => (
                    <tr key={company.ID}>
                      <td data-label="Select">
                        <button onClick={() => handleRowSelect(company)}>
                          Select
                        </button>
                      </td>
                      <td data-label="Category Code">{company.CategoryCode}</td>
                      <td data-label="Description">{company.Description}</td>
                      <td data-label="Depreciation">{company.Depreciation}</td>
                      <td data-label="Depreciation Days">
                        {company.DepreciationYear}
                      </td>
                      <td data-label="Created By">{company.CreatedBy}</td>
                      <td data-label="Created Date">
                        {new Date(company.CreatedDate).toLocaleString()}
                      </td>
                      <td data-label="Updated By">{company.ModifyBy}</td>
                      <td data-label="Updated Date">
                        {company.ModifyDate
                          ? new Date(company.ModifyDate).toLocaleString()
                          : ""}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <Box
              sx={{
                mt: 2,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Typography variant="body2" sx={{ marginRight: 2 }}>
                Showing {(page - 1) * rowsPerPage + 1} to{" "}
                {Math.min(page * rowsPerPage, filteredRows.length)} of{" "}
                {filteredRows.length} entries
              </Typography>
              <Pagination
                count={Math.ceil(filteredRows.length / rowsPerPage)}
                page={page}
                onChange={handleChangePage}
                size="small"
              />
            </Box>
          </Paper>
        </Box>
      </Container>
    </>
  );
};

export default CategoryMaster;
